import { useAuditActivities } from '@/features/audit';
import type { AuditAction, AuditActivityItem } from '@/services';
import { useMemo } from 'react';

/** Ações gravadas pela tela de formas de pagamento (e pela migração do catálogo). */
export const PAYMENT_SETTINGS_AUDIT_ACTIONS: AuditAction[] = [
  'product.payment-gateway.update',
  'product.payment-methods.update',
  'product.payment-methods.import',
];

/**
 * Histórico de quem alterou as formas de pagamento do produto, com o "de/para".
 *
 * Lê a trilha de auditoria do produto e fica só com as ações desta tela — a
 * trilha do produto também traz, por exemplo, o modo de emissão.
 */
export function usePaymentSettingsHistory(productCode: string) {
  const query = useAuditActivities(
    productCode ? { subjectType: 'product', subjectId: productCode } : null
  );

  const items = useMemo<AuditActivityItem[]>(
    () =>
      (query.data?.pages ?? [])
        .flatMap(page => page.items)
        .filter(item => PAYMENT_SETTINGS_AUDIT_ACTIONS.includes(item.action)),
    [query.data]
  );

  return {
    items,
    isLoading: query.isLoading,
    error: query.error,
    hasNextPage: Boolean(query.hasNextPage),
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
    refetch: query.refetch,
  };
}
